export enum ActivityType {
  "sport" = "sport",
  "leisure" = "leisure",
  "formula" = "formula",
  "lesson" = "lesson",
}
